/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-26T09:20:14.988
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHousePutawayItem,
	listRentHousePutawayItemInit,
	listRentHousePutawayItemByAuthorizations,
	deleteRentHousePutawayItem,
	downloadRentHousePutAwayTemplate
} from '@api/rentmanage/RentHousePutawayItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHousePutawayItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutawayItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		downloadRentHousePutAwayTemplate({
			dispatch,
			state,
		}) {
			return new Promise((resolve, reject) => {
				downloadRentHousePutAwayTemplate()
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		listRentHousePutawayItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutawayItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHousePutawayItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutawayItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHousePutawayItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHousePutawayItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
